import React, { useContext, useState, useRef } from 'react';
import axios, { AxiosError } from 'axios';
import ym from 'react-yandex-metrika';

import { Input, RadioInput, Button, Capture } from '@/components';
import { PageContext } from '@/Page';

import { formToValueSerializer } from './utils';
import styles from './form.module.scss';

export const URL = 'https://fit-service-bitrix.ru/local/rest_api/addLead.php';

export interface IFormValues {
  firstName: string;
  secondName: string;
  patronymic: string;
  phone: string;
  email: string;
  variant: string;
}

const defaultValues: IFormValues = {
  firstName: '',
  secondName: '',
  patronymic: '',
  phone: '',
  email: '',
  variant: ''
};

const Form: React.FC = () => {
  const [values, setValues] = useState<IFormValues>(defaultValues);
  const [isEmailValid, setEmailValid] = useState<boolean>(true);
  const [isPhoneValid, setPhoneValid] = useState<boolean>(true);
  const [isCaptureValid, setCaptureValid] = useState<boolean>(false);
  const { handleClose, condition, setCondition } = useContext(PageContext);
  const form = useRef<HTMLFormElement>(null);
  const isValid = isEmailValid && isPhoneValid && isCaptureValid;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;

    setValues((prev) => ({
      ...prev,
      [id]: value
    }));
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setValues((prev) => ({
      ...prev,
      variant: value
    }));
  };

  const handleYandexCounter = () => {
    switch (condition) {
      case 1:
        ym('reachGoal', 'first_form');
        break;
      case 2:
        ym('reachGoal', 'second form');
        break;
      case 3:
        ym('reachGoal', 'third_form');
        break;
      case 4:
        ym('reachGoal', 'form_four');
        break;

      default:
        break;
    }

    setCondition(1);
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const data = formToValueSerializer(values);

    axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        console.log(response, 'response');
        handleClose();
        setValues(defaultValues);
        form?.current?.reset();
        handleYandexCounter();
      })
      .catch((error: AxiosError) => {
        console.error(error);
      });
  };

  return (
    <form ref={form} className={styles.form} onSubmit={onSubmit}>
      <h2 className={styles.form__title}>Оставить заявку</h2>
      <p className={styles.form__text}>Введите ваши данные</p>
      <Input
        id='secondName'
        name='secondName'
        className={styles.form__input}
        placeholder='Введите фамилию'
        type='text'
        onChange={handleChange}
      />
      <Input
        id='firstName'
        name='firstName'
        className={styles.form__input}
        placeholder='Введите имя'
        type='text'
        onChange={handleChange}
      />
      <Input
        id='patronymic'
        name='patronymic'
        className={styles.form__input}
        placeholder='Введите отчество'
        type='text'
        onChange={handleChange}
      />
      <Input
        id='phone'
        name='phone'
        className={styles.form__input}
        placeholder='+7 XXX XXX - XX - XX'
        value={values.phone}
        type='number'
        autoComplete='on'
        onChange={handleChange}
        isValid={isPhoneValid}
        setValid={setPhoneValid}
      />
      <Input
        id='email'
        name='email'
        className={styles.form__input}
        placeholder='Email'
        value={values.email}
        type='email'
        autoComplete='on'
        onChange={handleChange}
        isValid={isEmailValid}
        setValid={setEmailValid}
      />
      <p className={styles.form__text}>Как с вами связаться?</p>
      <fieldset className={styles.form__fieldset}>
        <RadioInput
          name='variant'
          className={styles.form__scale}
          label='По телефону'
          value='телефон'
          onChange={handleRadioChange}
        />
        <RadioInput
          className={styles.form__scale}
          name='variant'
          label='По почте'
          value='почта'
          onChange={handleRadioChange}
        />
      </fieldset>
      <Capture setCaptureValid={setCaptureValid} />
      <Button
        className={styles.form__button}
        type='submit'
        disabled={!Object.values(values).every((key) => key !== '') || !isValid}
      >
        Отправить
      </Button>
      <p className={styles.form__info}>
        Отправляя заявку, вы даете{' '}
        <a
          href='https://novosibirsk.fitauto.ru/new/assets/files/politika-konfidencialnosti-ooo.pdf'
          target='_blank'
          rel='noreferrer'
          className={styles.form__link}
        >
          согласие на обработку
        </a>{' '}
        своих персональных данных в соответствии с{' '}
        <a
          href='https://novosibirsk.fitauto.ru/new/assets/files/politika-konfidencialnosti-ooo.pdf'
          target='_blank'
          rel='noreferrer'
          className={styles.form__link}
        >
          политикой конфиденциальности
        </a>
        .
      </p>
    </form>
  );
};

export default Form;
